export class Gateway {

  public name: string;
  public id: string;
  public sellerId: string;
  public publicKey: string;
  public vendorId: string;

  public get isPayPal(): boolean {
    return this.id === Gateways.PayPal;
  }

  public get is2Checkout(): boolean {
    return this.id === Gateways.TCheckout;
  }

  public get isBitpay(): boolean {
    return this.id === Gateways.Bitpay;
  }

  public get isPaddle(): boolean {
    return this.id === Gateways.Paddle;
  }
}

export enum Gateways {
  PayPal = 'paypalexpress',
  TCheckout = '2checkout_onsite',
  Bitpay = 'bitpay',
  Paddle = 'paddle'
}
